import { IMediaFile, IScene } from "../../api/media/MediaApi";

export class Scene {
  public name?: string;
  public scene?: MediaFile;
  public thumbnail?: MediaFile;
  public preview?: MediaFile;

  constructor(source?: IScene) {
    if (source) {
      this.name = source.Name;
      if (source.Scene)
        this.scene = MediaFile.convertFrom(source.Scene);
      if (source.Thumbnail)
        this.thumbnail = MediaFile.convertFrom(source.Thumbnail);
      if (source.Preview)
        this.preview = MediaFile.convertFrom(source.Preview);
    }
  }

  public static convertFrom(source: IScene): Scene {
    return new Scene(source)
  }
}

export class MediaFile {
  public fileName?: string;
  public fileType?: string;
  public creationDate?: string;
  public description?: string;
  public contentLength?: number;
  public contentType?: string;

  constructor(source?: IMediaFile) {
    if (source) {
      this.fileName = source.FileName;
      this.fileType = source.FileType;
      this.creationDate = source.CreationDate;
      this.description = source.Description;
      this.contentLength = source.ContentLength;
      this.contentType = source.ContentType;
    }
  }

  public static convertFrom(source: IMediaFile): MediaFile {
    return new MediaFile(source)
  }
}
